import React from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { Screen } from '../../components/lease/Screen'
import { BrandHeading } from '../../components/lease/BrandHeading'
import { PrimaryButton } from '../../components/lease/PrimaryButton'

// adportal hand-off — mirrors the renter Part A pattern exactly. The CTA
// reads the JWT straight from localStorage (same auth_token key the shared
// axios instance uses) and the document_id from route state or the query
// string, then hands off to the separate adportal app.
const ADPORTAL_URL = import.meta.env.DEV
  ? 'http://localhost:5176/adportal.html'
  : 'https://adportal.coloradoleasecheck.com/'

export function AttorneyHandoff() {
  const location = useLocation()
  const [params] = useSearchParams()
  const documentId = location.state?.documentId || params.get('document_id')

  const handleTalkToAttorney = () => {
    const token = localStorage.getItem('auth_token')
    const url = new URL(ADPORTAL_URL)
    if (token) url.searchParams.set('token', token)
    if (documentId) url.searchParams.set('document_id', documentId)
    window.location.assign(url.toString())
  }

  return (
    <Screen className="text-center">
      <header className="animate-fade-in">
        <BrandHeading className="text-4xl">Talk to an Attorney</BrandHeading>
        <p className="mt-4 text-slate-600 dark:text-slate-300">
          Send your lease and redline draft to a Colorado attorney you choose. LeaseCheck
          hands off the documents — the attorney relationship is yours.
        </p>
      </header>

      <PrimaryButton onClick={handleTalkToAttorney} className="mt-8 animate-slide-in">
        Talk to an Attorney
      </PrimaryButton>

      <p className="mt-6 text-xs text-slate-500 dark:text-slate-400">
        This is not legal advice. LeaseCheck does not select or endorse specific attorneys.
      </p>
    </Screen>
  )
}

export default AttorneyHandoff
